import React, { useState } from "react";
import Header from "../components/Header3";
import Footer from "../Screen/Footer";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { Row, Col } from "react-bootstrap";
import Blog1 from "../Images/Blog1.jpg";
import Blog2 from "../Images/blog2.jpg";
import Blog3 from "../Images/blog3.jpg";
import Blog4 from "../Images/blog4.jpg";
import Blog6 from "../Images/Blog6.jpg";
import Blog5 from "../Images/blog5.jpg"
import Blog7 from "../Images/blog7.jpg";
import Blog8 from "../Images/blog8.jpg";
import Blog11 from "../Images/Blog11.jpg";
import Blog12 from "../Images/Blog12.jpg";
import Blog13 from "../Images/Blog13.jpg";
import Blog14 from "../Images/Blog14.jpg";
import Blog15 from "../Images/Blog15.jpg";
import Blog9 from "../Images/Blog9.png";
import Blog10 from "../Images/Blog10.png";
import Blog18 from "../Images/Blog18.jpg";
import Blog17 from "../Images/Blog17.jpg";
import Blog16 from "../Images/Blog16.jpg";

import "../Screen/blogs.css";

const allBlogs = [
  {
    id: 1,
    category: "realEstate",
    title:
      "From Clicks to Visits: Lean Strategies to Convert Real Estate Leads into Property Viewings",
    date: "25 November 2024",
    desc: "Struggling to turn real estate leads into property viewings? Discover lean strategies to optimize your lead conversion process and drive more visits to your properties.",
    img: Blog2,
    link: "/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings",
  },
  {
    id: 2,
    category: "realEstate",
    title: "7 Game-Changing Tips to Attract High-Quality Leads",
    date: "25 November 2024",
    desc: "Meta Ads is a great platform for generating high-quality leads. In this blog, we'll explore seven tips to help you attract top-notch leads using Meta Ads. You'll also learn why focusing on lead quality.",
    img: Blog4,
    link: "/7-game-changing-tips-to-attract-high-quality-leads-with-meta-ads",
  },
  {
    id: 3,
    category: "eCommerce",
    title:
      "11 Proven Ways to Attract High-Quality Leads Using Google Ads (2024)",
    date: "25 November 2024",
    desc: "Google Ads is the best way to attract High-converting leads that drive business growth. To ensure your ads reach potential customers, it's crucial to use targeted strategies.",
    img: Blog3,
    link: "/11-proven-ways-to-attract-high-quality-leads-using-google-ads-2024",
  },
  {
    id: 4,
    category: "eCommerce",
    title:
      "How to Generate Leads on a Zero Marketing Budget: B2C and B2B Strategies",
    date: "25 November 2024",
    desc: "Generating leads is important for any business. There are effective ways to attract potential customers and clients without spending money. In this guide, we'll look at lead generation",
    img: Blog5,
    link: "/how-to-generate-leads-on-a-zero-marketing-budget-b2c-and-b2b-strategies",
  },
  {
    id: 5,
    category: "realEstate",
    title:
      "From Clicks to Visits: Lean Strategies to Convert Real Estate Leads into Property Viewings",
    date: "25 November 2024",
    desc: "Struggling to turn real estate leads into property viewings? Discover lean strategies to optimize your lead conversion process and drive more visits to your properties.",
    img: Blog2,
    link: "/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings",
  },
  {
    id: 6,
    category: "health",
    title: "8 Proven Ways to Get More Leads for Your Dental Clinic",
    date: "23 September 2025",
    desc: "Strategies to boost patient acquisition for your dental clinic.Explore both organic and paid lead generation methods to attract, engage, and convert prospective patients.",
    img: Blog6,
    link: "/8-proven-ways-to-get-more-leads-for-your-dental-clinic",
  },
  {
    id: 7,
    category: "realEstate",
    title:
      "Google Ads vs Meta Ads: Which is Better for Real Estate Lead Generation in India 2025",
    date: "23 September 2025",
    desc: "Explore Google Ads vs Meta Ads for real estate lead generation in India. Discover which platform suits your business goals, and learn best practices for maximizing your advertising efforts in 2025.",
    img: Blog7,
    link: "/google-ads-vs-meta-ads-which-is-better-for-real-estate-lead-generation-in-india-2025",
  },
  {
    id: 8,
    category: "realEstate",
    title:
      "7 Proven Ways to Generate Real Estate Leads with Google Ads | Blaccdot",
    date: "23 September 2025",
    desc: "The proven strategies to generate high-quality real estate leads using Google Ads. Optimize your campaigns with effective keyword targeting, compelling ad copy, and efficient lead management with Blaccdot.",
    img: Blog8,
    link: "/7-proven-ways-to-generate-real-estate-leads-with-google-ads-blaccdot",
  },
  {
    id: 9,
    category: "realEstate",
    title:
      "Biggest Real Estate Lead Generation Challenges in India and Solutions",
    date: "23 September 2025",
    desc: "Struggling with real estate leads? Discover the 8 biggest real estate lead generation challenges in India—from unqualified leads to high competition—and learn actionable solutions for real estate business success",
    img: Blog9,
    link: "/biggest-real-estate-lead-generation-challenges-in-india-and-solutions",
  },
  {
    id: 10,
    category: "realEstate",
    title:
      "How to Create a Winning Real Estate Leads Funnel in India for Higher Sales",
    date: "23 September 2025",
    desc: "Learn the 7 steps to build a high-converting real estate leads funnel in India. Master capturing, nurturing, and converting leads with targeted ads, buyer personas, and powerful retargeting strategies.",
    img: Blog10,
    link: "/how-to-create-a-winning-real-estate-leads-funnel-in-india-for-higher-sales",
  },
  {
    id: 11,
    category: "realEstate",
    title: "Proven Follow-Up Strategies for Real Estate Success in Chennai",
    date: "29 October 2025",
    desc: " Learn how to follow up smartly with real estate leads in Chennai. Turn enquiries into site visits with proven follow-up techniques.",
    img: Blog11,
    link: "/real-estate-follow-up-strategies-chennai",
  },
  {
    id: 12,
    category: "realEstate",
    title:
      "The Perfect Lead Follow-Up Timeline: When and How to Reach Out for Maximum Real Estate Conversions",
    date: "29 October 2025",
    desc: " Learn the ideal real estate follow-up schedule for Chennai property leads. Convert more buyers with our proven day-by-day timeline.",
    img: Blog12,
    link: "/real-estate-lead-follow-up-timeline-chennai",
  },
  {
    id: 13,
    category: "realEstate",
    title:
      "From Inquiry to Site Visit: How to Nurture Low-Intent Real Estate Leads in Chennai",
    date: "29 October 2025",
    desc: " Learn how to turn Low-Intent real estate leads into site visits with smart nurturing strategies designed for Chennai’s property market.",
    img: Blog13,
    link: "/nurture-real-estate-leads-chennai",
  },
  {
    id: 14,
    category: "realEstate",
    title:
      " The 7-Day Follow-Up Blueprint: Turn More Property Leads into Buyers Without Being Pushy",
    date: "30 October 2025",
    desc: " Follow this 7-day real estate follow-up blueprint to convert more Chennai property leads into site visits — without sounding pushy.",
    img: Blog14,
    link: " /7-day-follow-up-plan-chennai-real-estate",
  },
  {
    id: 15,
    category: "realEstate",
    title:
      "How to Build Trust with Real Estate Leads: The Long-Term Conversion Secret for Chennai Property Sellers",
    date: "30 October 2025",
    desc: " Learn how Chennai property sellers can build trust and convert more real estate leads with authenticity, proof, and consistent communication",
    img: Blog15,
    link: "/real-estate-lead-trust-building-chennai",
  },
  {
    id: 16,
    category: "realEstate",
    title: " Ideas to Generate Leads for Luxury Properties in Chennai",
    date: "30 October 2025",
    desc: "Are you a real estate business owner in Chennai? Learn expert real estate leads generation strategies for luxury properties, focusing on digital marketing, exclusive events, and making site visits an unforgettable experience. Boost your sales today!",
    img: Blog16,
    link: " /lead-generation-for-luxury-properties-in-chennai",
  },
  {
    id: 17,
    category: "realEstate",
    title:
      "ATL vs BTL vs TTL Marketing: Which is best for real estate Lead Generation",
    date: "31 October 2025",
    desc: "Confused about ATL, BTL, & TTL for real estate leads generation in Chennai? Learn which marketing strategy is best to get high-quality real estate leads for your projects.",
    img: Blog17,
    link: "/atl-vs-btl-vs-ttl-marketing-real-estate-lead-generation",
    
  },
  {
    id: 18,
    category: "realEstate",
    title:
      "Real Estate Lead Generation in Tier 2 and 3 Cities in India",
    date: "31 October 2025",
    desc: "Unlock effective real estate lead generation in Chennai (and Tamil Nadu's Tier 2/3 cities). Discover hyper-local digital and traditional strategies to capture high-intent real property buyers and secure quality real estate leads in fast-growing markets",
    img: Blog18,
    link: "/real-estate-lead-generation-tier-2-3-cities-india",
    
  },
];

const Blogs = () => {
  const [filter, setFilter] = useState("all");

  const filteredBlogs = allBlogs.filter(
    (blog) =>
      filter === "all" ||
      blog.category.toLowerCase().trim() === filter.toLowerCase().trim()
  );

  return (
    <div>
      <Header />
      <div className="container my-5">
        <Row>
          <Col md={9}>
            <Row className="mb-4">
              <Col md={12}>
                <a
                  href="/10-lean-strategies-to-boost-e-commerce-roas"
                  style={{ textDecoration: "none" }}
                >
                  <Card sx={{ maxWidth: "100%" }}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        height="250"
                        image={Blog1}
                        alt="blog1"
                      />
                      <CardContent>
                        <p style={{ fontSize: "smaller", color: "#676767" }}>
                          Publish Date | 25 November 2024
                        </p>
                        <Typography gutterBottom variant="h5" component="div">
                          10 Lean Strategies to Boost E-commerce ROAS | Blaccdot
                          Guide
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          Discover 10 lean strategies to enhance your e-commerce
                          ROAS and drive sales.
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </Col>
            </Row>

            <Row className="mb-4 mt-4 filter-buttons">
              {["all", "realEstate", "eCommerce", "health"].map((cat) => (
                <Col key={cat} xs="auto">
                  <button
                    className={`filter-btn ${filter === cat ? "active" : ""}`}
                    onClick={() => setFilter(cat)}
                  >
                    {cat === "all"
                      ? "All"
                      : cat === "realEstate"
                      ? "Real Estate"
                      : cat === "eCommerce"
                      ? "E-Commerce"
                      : cat === "health"
                      ? "Health Care"
                      : cat}
                  </button>
                </Col>
              ))}
            </Row>
          </Col>

          <Col
            md={3}
            className="mb-4"
            style={{ height: "70vh", overflowY: "auto" }}
          >
            <h5 style={{ color: "#1C3046", marginBottom: "20px" }}>
              Pick your favorite
            </h5>
            {allBlogs.map((blog) => (
              <a
                key={blog.id}
                href={blog.link}
                style={{ textDecoration: "none" }}
              >
                <div className="mb-4 blogSidelist">
                  <span style={{ color: "#2763b1", fontSize: "smaller" }}>
                    LEARN
                  </span>
                  <h6 style={{ color: "#554f4f" }}>{blog.title}</h6>
                </div>
              </a>
            ))}
          </Col>
        </Row>

        <Row>
          {filteredBlogs.map((blog) => (
            <Col md={4} className="mb-4" key={blog.id}>
              <a href={blog.link} style={{ textDecoration: "none" }}>
                <Card sx={{ maxWidth: "100%" }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="200"
                      image={blog.img}
                      alt={blog.title}
                    />
                    <CardContent>
                      <p style={{ fontSize: "smaller", color: "#676767" }}>
                        Publish Date | {blog.date}
                      </p>
                      <Typography gutterBottom variant="h6" component="div">
                        {blog.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary" }}
                      >
                        {blog.desc}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </a>
            </Col>
          ))}
        </Row>
      </div>
      <Footer />
    </div>
  );
};

export default Blogs;

// import React, { useState } from "react";
// import Header from "../components/Header3";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import CardMedia from "@mui/material/CardMedia";
// import Typography from "@mui/material/Typography";
// import CardActionArea from "@mui/material/CardActionArea";
// import { Row, Col } from "react-bootstrap";
// import Blog1 from "../Images/Blog1.jpg";
// import Blog2 from "../Images/blog2.jpg";
// import Blog3 from "../Images/blog3.jpg";
// import Blog4 from "../Images/blog4.jpg";
// import Blog5 from "../Images/blog5.jpg";
// import Blog7 from "../Images/blog7.jpg";
// import Blog8 from "../Images/blog8.jpg";
// import Footer from "../Screen/Footer";

// const Blogs = () => {
//   const [filter, setFilter] = useState("all");
//   return (
//     <div>
//       <Header />
//       <div className="container my-5">
//         <Row>
//           <Col md={9}>
//             <Row>
//               <Col md={12}>
//                 <a
//                   href="/10-lean-strategies-to-boost-e-commerce-roas"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="250"
//                         image={Blog1}
//                         alt="green iguana"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 25 November 2024
//                         </p>
//                         <Typography gutterBottom variant="h5" component="div">
//                           10 Lean Strategies to Boost E-commerce ROAS | Blaccdot
//                           Guide
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Discover 10 lean strategies to enhance your e-commerce
//                           ROAS and drive sales. A must-read guide for business
//                           owners struggling with sales.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>

//               {(filter === "all" || filter === "realEstate") && (
//                 <Col md={6} className="mt-4">
//                   <a
//                     href="/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <Card sx={{ maxWidth: "100%" }}>
//                       <CardActionArea>
//                         <CardMedia
//                           component="img"
//                           height="100%"
//                           image={Blog2}
//                           alt="green iguana"
//                         />
//                         <CardContent>
//                           <p style={{ fontSize: "smaller", color: "#676767" }}>
//                             Publish Date | 25 November 2024
//                           </p>
//                           <Typography gutterBottom variant="h6" component="div">
//                             From Clicks to Visits: Lean Strategies to Convert
//                             Real Estate Leads into Property Viewings
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ color: "text.secondary" }}
//                           >
//                             Struggling to turn real estate leads into property
//                             viewings? Discover lean strategies to optimize your
//                             lead conversion process and drive more visits to
//                             your properties.
//                           </Typography>
//                         </CardContent>
//                       </CardActionArea>
//                     </Card>
//                   </a>
//                 </Col>
//               )}
//               {(filter === "all" || filter === "eCommerce") && (
//                 <Col md={6} className="mt-4">
//                   <a
//                     href="/7-game-changing-tips-to-attract-high-quality-leads-with-meta-ads"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <Card sx={{ maxWidth: "100%" }}>
//                       <CardActionArea>
//                         <CardMedia
//                           component="img"
//                           height="100%"
//                           image={Blog4}
//                           alt="green iguana"
//                         />
//                         <CardContent>
//                           <p style={{ fontSize: "smaller", color: "#676767" }}>
//                             Publish Date | 25 November 2024
//                           </p>
//                           <Typography gutterBottom variant="h6" component="div">
//                             7 Game-Changing Tips to Attract High-Quality Leads
//                             Using Meta Ads
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ color: "text.secondary" }}
//                           >
//                             Meta Ads is a great platform for generating
//                             high-quality leads. In this blog, we'll explore
//                             seven tips to help you attract top-notch leads using
//                             Meta Ads. You'll also learn why focusing on lead
//                             quality.
//                           </Typography>
//                         </CardContent>
//                       </CardActionArea>
//                     </Card>
//                   </a>
//                 </Col>
//               )}
//             </Row>
//           </Col>

//           <Col
//             md={3}
//             className="sign-up-image"
//             style={{ height: "100vh", overflowY: "auto" }}
//           >
//             <h5 style={{ color: "#1C3046", marginBottom: "20px" }}>
//               Pick your favorite
//             </h5>
//             <a
//               href="/10-lean-strategies-to-boost-e-commerce-roas"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   10 Lean Strategies to Boost E-commerce ROAS | Blaccdot Guide
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   From Clicks to Visits: Lean Strategies to Convert Real Estate
//                   Leads into Property Viewings
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/11-proven-ways-to-attract-high-quality-leads-using-google-ads-2024"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   INFORMATION
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   11 Proven Ways to Attract High-Quality Leads Using Google Ads
//                   (2024)
//                 </h6>
//               </div>
//             </a>

//             <a
//               href="/7-game-changing-tips-to-attract-high-quality-leads-with-meta-ads"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   INFORMATION
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   7 Game-Changing Tips to Attract High-Quality Leads Using Meta
//                   Ads
//                 </h6>
//               </div>
//             </a>

//             <a
//               href="/how-to-generate-leads-on-a-zero-marketing-budget-b2c-and-b2b-strategies"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   HOW TO
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   How to Generate Leads on a Zero Marketing Budget: B2C and B2B
//                   Strategies
//                 </h6>
//               </div>
//             </a>

//             <a
//               href="/8-proven-ways-to-get-more-leads-for-your-dental-clinic"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   8 Proven Ways to Get More Leads for Your Dental Clinic
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/google-ads-vs-meta-ads-which-is-better-for-real-estate-lead-generation-in-india-2025"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   Google Ads vs Meta Ads: Which is Better for Real Estate Lead
//                   Generation in India 2025
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/7-proven-ways-to-generate-real-estate-leads-with-google-ads-blaccdot"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   7 Proven Ways to Generate Real Estate Leads Through Google Ads
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/biggest-real-estate-lead-generation-challenges-in-india-and-solutions"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   Biggest Real Estate Lead Generation Challenges in India and
//                   Solutions s{" "}
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/how-to-create-a-winning-real-estate-leads-funnel-in-india-for-higher-sales"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   How to Create a Winning Real Estate Leads Funnel in India for
//                   Higher Sales
//                 </h6>
//               </div>
//             </a>
//           </Col>
//         </Row>

//         <div className="mt-5">
//           <Row>
//             {(filter === "all" || filter === "eCommerce") && (
//               <Col md={4}>
//                 <a
//                   href="/11-proven-ways-to-attract-high-quality-leads-using-google-ads-2024"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog3}
//                         alt="green iguana"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 25 November 2024
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           11 Proven Ways to Attract High-Quality Leads Using
//                           Google Ads (2024)
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Google Ads is the best way to attract High-converting
//                           leads that drive business growth. To ensure your ads
//                           reach potential customers, it's crucial to use
//                           targeted strategies.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "eCommerce") && (
//               <Col md={4}>
//                 <a
//                   href="/how-to-generate-leads-on-a-zero-marketing-budget-b2c-and-b2b-strategies"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog5}
//                         alt="green iguana"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 25 November 2024
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           How to Generate Leads on a Zero Marketing Budget: B2C
//                           and B2B Strategies
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Generating leads is important for any business. There
//                           are effective ways to attract potential customers and
//                           clients without spending money. In this guide, we'll
//                           look at lead generation
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog1}
//                         alt="green iguana"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 25 November 2024
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           From Clicks to Visits: Lean Strategies to Convert Real
//                           Estate Leads into Property Viewings
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Struggling to turn real estate leads into property
//                           viewings? Discover lean strategies to optimize your
//                           lead conversion process and drive more visits to your
//                           properties.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//           </Row>
//         </div>

//         <div className="mt-5">
//           <Row>
//             {(filter === "all" || filter === "health") && (
//               <Col md={4}>
//                 <a
//                   href="/8-proven-ways-to-get-more-leads-for-your-dental-clinic"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog1} //need image
//                         alt="Blog6"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           8 Proven Ways to Get More Leads for Your Dental Clinic
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Strategies to boost patient acquisition for your
//                           dental clinic. Explore both organic and paid lead
//                           generation methods to attract, engage, and convert
//                           prospective patients.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/google-ads-vs-meta-ads-which-is-better-for-real-estate-lead-generation-in-india-2025"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog7} //need image
//                         alt="Blog7"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           Google Ads vs Meta Ads: Which is Better for Real
//                           Estate Lead Generation in India 2025
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Explore the differences between Google Ads and Meta
//                           Ads for real estate lead generation in India. Discover
//                           which platform suits your business goals, and learn
//                           best practices for maximizing your advertising efforts
//                           in 2025.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/7-proven-ways-to-generate-real-estate-leads-with-google-ads-blaccdot"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog8} //need image
//                         alt="Blog8"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           7 Proven Ways to Generate Real Estate Leads with
//                           Google Ads | Blaccdot
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           The proven strategies to generate high-quality real
//                           estate leads using Google Ads. Optimize your campaigns
//                           with effective keyword targeting, compelling ad copy,
//                           and efficient lead management with Blaccdot.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//           </Row>
//         </div>

//         <div className="mt-5">
//           <Row>
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/biggest-real-estate-lead-generation-challenges-in-india-and-solutions"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog1} //need image
//                         alt="Blog9"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           Biggest Real Estate Lead Generation Challenges in
//                           India and Solutions
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Strategies to boost patient acquisition for your
//                           dental clinic. Explore both organic and paid lead
//                           generation methods to attract, engage, and convert
//                           prospective patients.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/how-to-create-a-winning-real-estate-leads-funnel-in-india-for-higher-sales"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog1} //need image
//                         alt="Blog10"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           How to Create a Winning Real Estate Leads Funnel in
//                           India for Higher Sales
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Explore the differences between Google Ads and Meta
//                           Ads for real estate lead generation in India. Discover
//                           which platform suits your business goals, and learn
//                           best practices for maximizing your advertising efforts
//                           in 2025.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//           </Row>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default Blogs;
